// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService, FlagsGuardService, PermissionsGuardService } from '@app/core';
import { AUTH_ROUTE, LOGOUT_ROUTE, ACCOUNT_SETTINGS_ROUTE, IAM_ROUTE } from '@app/core/utilities';
import { AuthComponent } from './shared/auth-page/auth-page.component';

const routes: Routes = [
  {
    path: 'projects/:id/memberonboarding',
    loadChildren: 'app/memberonboarding/memberonboarding.module#MemberonboardingModule',
    canActivate: [AuthGuardService, FlagsGuardService],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'projects',
    loadChildren: 'app/project/project.module#ProjectModule',
    canActivate: [AuthGuardService, FlagsGuardService],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'docusign',
    loadChildren: 'app/landing-pages/landing-pages.module#LandingPagesModule',
    canActivate: [AuthGuardService, FlagsGuardService],
    runGuardsAndResolvers: 'always'
  },
  {
    path: ACCOUNT_SETTINGS_ROUTE,
    loadChildren: 'app/account-settings/account-settings.module#AccountSettingsModule',
    canActivate: [AuthGuardService, PermissionsGuardService],
    runGuardsAndResolvers: 'always'
  },
  {
    path: IAM_ROUTE,
    loadChildren: 'app/access-management/access-management.module#AccessManagementModule',
    canActivate: [AuthGuardService, PermissionsGuardService],
    runGuardsAndResolvers: 'always'
  },
  {
    path: AUTH_ROUTE,
    component: AuthComponent
  },
  {
    path: LOGOUT_ROUTE,
    component: AuthComponent
  },
  {
    path: '**',
    redirectTo: IAM_ROUTE
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts